import { classNames } from "primereact/utils";

const dialog = {
    root: ({ state }) => ({
        className: classNames('rounded-lg shadow-lg border-0', 'max-h-[90%] transform scale-100', 'm-0 w-[75vw] max-w-[675px]', 'dark:border dark:border-blue-900/40', {
            'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized
        })
    }),
    header: {
        className: classNames('flex gap-4 items-center justify-between shrink-0', 'bg-allstate-blue text-white border-t-0  rounded-tl rounded-tr py-5 px-6', 'dark:bg-gray-900  dark:text-white/80')
    },
    headerTitle: 'font-medium text-xl',
    headerIcons: 'flex items-center',
    closeButton: {
        className: classNames(
            'flex items-center justify-center overflow-hidden relative',
            'w-8 h-8 bg-white text-allstate-navy gray-500 border border-grey-3 rounded-full transition duration-200 ease-in-out mr-2 last:mr-0',
            'hover:text-gray-700 hover:border-transparent hover:bg-gray-200',
            'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]', // focus
            'dark:hover:text-white/80 dark:hover:border-transparent dark:hover:bg-gray-800/80 dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)]'
        )
    },
    closeButtonIcon: 'w-4 h-4 inline-block',
    content: ({ state, props }) => ({
        className: classNames(
            'overflow-y-auto',
            'bg-white text-allstate-navy p-6 pb-8', 'dark:bg-gray-900  dark:text-white/80 ', 
            {
                'rounded-bl rounded-br': !props.footer,
                grow: state.maximized
            }
        )
    }),
    footer: {
        className: classNames('shrink-0 ', 'border-t-0 bg-white text-gray-700 px-6 pb-6 text-right rounded-b', 'dark:bg-gray-900  dark:text-white/80')
    },
    mask: ({ state }) => ({
        className: classNames('transition duration-200', { 'bg-black/40': state.containerVisible })
    }),
    transition: ({ props }) => {
        return props.position === 'top'
            ? {
                  enterFromClass: 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0',
                  enterActiveClass: 'transition-all duration-200 ease-out',
                  leaveActiveClass: 'transition-all duration-200 ease-out',
                  leaveToClass: 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0'
              }
            : props.position === 'bottom'
            ? {
                  enterFromClass: 'opacity-0 scale-75 translate-y-full',
                  enterActiveClass: 'transition-all duration-200 ease-out',
                  leaveActiveClass: 'transition-all duration-200 ease-out',
                  leaveToClass: 'opacity-0 scale-75 translate-x-0 translate-y-full translate-z-0'
              }
            : props.position === 'left' || props.position === 'top-left' || props.position === 'bottom-left'
            ? {
                  enterFromClass: 'opacity-0 scale-75 -translate-x-full translate-y-0 translate-z-0',
                  enterActiveClass: 'transition-all duration-200 ease-out',
                  leaveActiveClass: 'transition-all duration-200 ease-out',
                  leaveToClass: 'opacity-0 scale-75  -translate-x-full translate-y-0 translate-z-0'
              }
            : props.position === 'right' || props.position === 'top-right' || props.position === 'bottom-right'
            ? {
                  enterFromClass: 'opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0',
                  enterActiveClass: 'transition-all duration-200 ease-out',
                  leaveActiveClass: 'transition-all duration-200 ease-out',
                  leaveToClass: 'opacity-0 scale-75 opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0'
              }
            : {
                  enterFromClass: 'opacity-0 scale-75',
                  enterActiveClass: 'transition-all duration-200 ease-out',
                  leaveActiveClass: 'transition-all duration-200 ease-out',
                  leaveToClass: 'opacity-0 scale-75'
              };
    }
}

export default dialog;
        